import React, { useState } from "react";
import { FiToggleLeft, FiToggleRight, FiMail, FiMessageSquare, FiClock, FiCalendar, FiFile, FiUser, FiBell } from "react-icons/fi";

export default function NotificationsView() {
  const [notificationSettings, setNotificationSettings] = useState({
    email: {
      newCases: true,
      deadlines: true,
      documentUpdates: false,
      meetings: true,
      clientMessages: true
    },
    app: {
      newCases: true,
      deadlines: true,
      documentUpdates: true,
      meetings: true,
      clientMessages: true
    },
    digest: "daily"
  });

  const handleToggle = (category, setting) => {
    setNotificationSettings({
      ...notificationSettings,
      [category]: {
        ...notificationSettings[category],
        [setting]: !notificationSettings[category][setting]
      }
    });
  };

  const handleDigestChange = (value) => {
    setNotificationSettings({
      ...notificationSettings,
      digest: value
    });
  };

  const Toggle = ({ enabled, onChange }) => (
    <button
      className="focus:outline-none"
      onClick={onChange}
    >
      {enabled ? (
        <FiToggleRight className="h-6 w-6 text-navy-600" />
      ) : (
        <FiToggleLeft className="h-6 w-6 text-gray-400" />
      )}
    </button>
  );

  return (
    <div className="bg-white rounded-lg shadow-md">
      <div className="p-6 border-b">
        <h1 className="text-2xl font-bold text-navy-900 flex items-center">
          <FiBell className="mr-2" /> Configuración de Notificaciones
        </h1>
        <p className="text-gray-600 mt-2">
          Personaliza las notificaciones que recibes de Lawfeed.
        </p>
      </div>

      <div className="p-6">
        <div className="mb-8">
          <h2 className="text-lg font-semibold mb-4 flex items-center">
            <FiMail className="mr-2" /> Notificaciones por Correo Electrónico
          </h2>
          <div className="space-y-4">
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded">
              <div>
                <h3 className="font-medium">Nuevos casos</h3>
                <p className="text-sm text-gray-500">Recibe notificaciones cuando se asignen nuevos casos</p>
              </div>
              <Toggle 
                enabled={notificationSettings.email.newCases} 
                onChange={() => handleToggle("email", "newCases")} 
              />
            </div>
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded">
              <div>
                <h3 className="font-medium">Fechas límite</h3>
                <p className="text-sm text-gray-500">Recibe recordatorios de fechas límite importantes</p>
              </div>
              <Toggle 
                enabled={notificationSettings.email.deadlines} 
                onChange={() => handleToggle("email", "deadlines")} 
              />
            </div>
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded">
              <div>
                <h3 className="font-medium">Actualizaciones de documentos</h3>
                <p className="text-sm text-gray-500">Recibe notificaciones cuando se modifiquen documentos importantes</p>
              </div>
              <Toggle 
                enabled={notificationSettings.email.documentUpdates} 
                onChange={() => handleToggle("email", "documentUpdates")} 
              />
            </div>
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded">
              <div>
                <h3 className="font-medium">Reuniones</h3>
                <p className="text-sm text-gray-500">Recibe recordatorios de reuniones programadas</p>
              </div>
              <Toggle 
                enabled={notificationSettings.email.meetings} 
                onChange={() => handleToggle("email", "meetings")} 
              />
            </div>
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded">
              <div>
                <h3 className="font-medium">Mensajes de clientes</h3>
                <p className="text-sm text-gray-500">Recibe notificaciones cuando los clientes envíen mensajes</p>
              </div>
              <Toggle 
                enabled={notificationSettings.email.clientMessages} 
                onChange={() => handleToggle("email", "clientMessages")} 
              />
            </div>
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-lg font-semibold mb-4 flex items-center">
            <FiBell className="mr-2" /> Notificaciones en la Aplicación
          </h2>
          <div className="space-y-4">
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded">
              <div>
                <h3 className="font-medium">Nuevos casos</h3>
                <p className="text-sm text-gray-500">Recibe notificaciones cuando se asignen nuevos casos</p>
              </div>
              <Toggle 
                enabled={notificationSettings.app.newCases} 
                onChange={() => handleToggle("app", "newCases")} 
              />
            </div>
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded">
              <div>
                <h3 className="font-medium">Fechas límite</h3>
                <p className="text-sm text-gray-500">Recibe recordatorios de fechas límite importantes</p>
              </div>
              <Toggle 
                enabled={notificationSettings.app.deadlines} 
                onChange={() => handleToggle("app", "deadlines")} 
              />
            </div>
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded">
              <div>
                <h3 className="font-medium">Actualizaciones de documentos</h3>
                <p className="text-sm text-gray-500">Recibe notificaciones cuando se modifiquen documentos importantes</p>
              </div>
              <Toggle 
                enabled={notificationSettings.app.documentUpdates} 
                onChange={() => handleToggle("app", "documentUpdates")} 
              />
            </div>
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded">
              <div>
                <h3 className="font-medium">Reuniones</h3>
                <p className="text-sm text-gray-500">Recibe recordatorios de reuniones programadas</p>
              </div>
              <Toggle 
                enabled={notificationSettings.app.meetings} 
                onChange={() => handleToggle("app", "meetings")} 
              />
            </div>
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded">
              <div>
                <h3 className="font-medium">Mensajes de clientes</h3>
                <p className="text-sm text-gray-500">Recibe notificaciones cuando los clientes envíen mensajes</p>
              </div>
              <Toggle 
                enabled={notificationSettings.app.clientMessages} 
                onChange={() => handleToggle("app", "clientMessages")} 
              />
            </div>
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-lg font-semibold mb-4 flex items-center">
            <FiClock className="mr-2" /> Resumen de Actividad
          </h2>
          <div className="p-3 bg-gray-50 rounded">
            <h3 className="font-medium mb-2">Frecuencia de resumen</h3>
            <p className="text-sm text-gray-500 mb-4">Recibe un resumen de toda la actividad en tu cuenta</p>
            <div className="flex space-x-3">
              <button
                className={`px-4 py-2 rounded ${
                  notificationSettings.digest === "daily"
                    ? "bg-navy-600 text-white"
                    : "bg-gray-200 hover:bg-gray-300"
                }`}
                onClick={() => handleDigestChange("daily")}
              >
                Diario
              </button>
              <button
                className={`px-4 py-2 rounded ${
                  notificationSettings.digest === "weekly"
                    ? "bg-navy-600 text-white"
                    : "bg-gray-200 hover:bg-gray-300"
                }`}
                onClick={() => handleDigestChange("weekly")}
              >
                Semanal
              </button>
              <button
                className={`px-4 py-2 rounded ${
                  notificationSettings.digest === "monthly"
                    ? "bg-navy-600 text-white"
                    : "bg-gray-200 hover:bg-gray-300"
                }`}
                onClick={() => handleDigestChange("monthly")}
              >
                Mensual
              </button>
              <button
                className={`px-4 py-2 rounded ${
                  notificationSettings.digest === "none"
                    ? "bg-navy-600 text-white"
                    : "bg-gray-200 hover:bg-gray-300"
                }`}
                onClick={() => handleDigestChange("none")}
              >
                Ninguno
              </button>
            </div>
          </div>
        </div>

        <div className="mt-8">
          <div className="flex justify-between">
            <button
              className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded"
              onClick={() => {
                // Reset to default settings
                setNotificationSettings({
                  email: {
                    newCases: true,
                    deadlines: true,
                    documentUpdates: false,
                    meetings: true,
                    clientMessages: true
                  },
                  app: {
                    newCases: true,
                    deadlines: true,
                    documentUpdates: true,
                    meetings: true,
                    clientMessages: true
                  },
                  digest: "daily"
                });
              }}
            >
              Restablecer Valores Predeterminados
            </button>
            <button
              className="px-4 py-2 bg-navy-600 text-white hover:bg-navy-700 rounded"
              onClick={() => {
                // Save notification settings
                console.log("Guardando configuración:", notificationSettings);
                // Here you would typically make an API call to save the settings
              }}
            >
              Guardar Cambios
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}